module.exports = __webpack_public_path__ + "img/banner.f6f85e60.png";